export const InitialValuesForRejected = {
    rejectedReason: ""
}